import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import About from '@/views/About'
import Home from '@/views/Home'
import Login from '@/views/Login'
import Lost from '@/views/Lost'
import PasswordReset from '@/views/PasswordReset'
import Signup from '@/views/Signup'
import VerifyEmail from '@/views/VerifyEmail'

Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/verify-email',
      name: 'verify-email',
      component: VerifyEmail
    },
    {
      path: '/password-reset',
      name: 'password-reset',
      component: PasswordReset,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '*',
      component: Lost
    }
  ]
})
